import { Module } from 'vuex';

import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';
import { RootState } from '@/store/types';

import subscribableStore from './common';
import { RulesState } from './types';

function initialState(): RulesState {
  return { ...initialStateSubscribable() };
}

const vuexModule: Module<RulesState, RootState> = {
  namespaced: true,
  state: initialState(),
  mutations: { ...subscribableStore.mutations },
  actions: { ...subscribableStore.actions },
  getters: { ...subscribableStore.getters },
};

export default vuexModule;
